// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/marketing/app_promotion/v1/app_promotion.proto (package stailer_service_specification.marketing.app_promotion.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/marketing/app_promotion/v1/app_promotion.proto.
 */
const file_stailer_service_specification_marketing_app_promotion_v1_app_promotion = /*@__PURE__*/
  fileDesc("CkxzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tYXJrZXRpbmcvYXBwX3Byb21vdGlvbi92MS9hcHBfcHJvbW90aW9uLnByb3RvEjhzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5tYXJrZXRpbmcuYXBwX3Byb21vdGlvbi52MSKhAgoNSW5zdGFsbEJhbm5lchKLAQoFdGl0bGUYASABKAlCfJKCGUXjgqTjg7Pjgrnjg4jjg7zjg6vjg5Djg4rjg7zjgavooajnpLrjgZnjgovjgrXjg7zjg5PjgrnooajoqJjjgafjgZnjgIKqghkn44Kk44Oz44K544OI44O844Or44OQ44OK44O844K/44Kk44OI44OruIIZA8CCGQESgQEKCmFkanVzdF91cmwYAiABKAlCbZKCGTbjgqTjg7Pjgrnjg4jjg7zjg6vjg5Djg4rjg7zjga7jg6rjg7Pjgq/lhYhVUkzjgafjgZnjgIKqghkn44Kk44Oz44K544OI44O844Or44OQ44OK44O844Oq44Oz44Kv5YWIuIIZA8CCGQEi0AEKDEFwcFByb21vdGlvbhK/AQoOaW5zdGFsbF9iYW5uZXIYASABKAsyRy5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5tYXJrZXRpbmcuYXBwX3Byb21vdGlvbi52MS5JbnN0YWxsQmFubmVyQl6Sghkt44Kk44Oz44K544OI44O844Or44OQ44OK44O844Gu6Kit5a6a44Gn44GZ44CCqoIZIeOCpOODs+OCueODiOODvOODq+ODkOODiuODvOioreWumriCGQPAghkBYgZwcm90bzM", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.marketing.app_promotion.v1.InstallBanner.
 * Use `create(InstallBannerSchema)` to create a new message.
 */
const InstallBannerSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_app_promotion_v1_app_promotion, 0);

/**
 * Describes the message stailer_service_specification.marketing.app_promotion.v1.AppPromotion.
 * Use `create(AppPromotionSchema)` to create a new message.
 */
const AppPromotionSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_app_promotion_v1_app_promotion, 1);


exports.file_stailer_service_specification_marketing_app_promotion_v1_app_promotion = file_stailer_service_specification_marketing_app_promotion_v1_app_promotion;
exports.InstallBannerSchema = InstallBannerSchema;
exports.AppPromotionSchema = AppPromotionSchema;
